export const getOutputName = (module: string) => {
	switch (module) {
		case 'budget':
			return 'BudgetOutput-v1'
		case 'debtOverview':
			return 'DebtOverviewOutput-v1'
		case 'incomeVerification':
			return 'IncomeVerificationOutput-v1'
		case 'questionnaire':
			return 'QuestionnaireOutput-v1'
		case 'customQuestionnaire':
			return 'CustomQuestionnaireOutput-v1'
		case 'assetOverview':
			return 'AssetOverviewOutput-v1'
		case 'assetExpenses':
			return 'AssetExpensesOutput-v1'
		case 'assetReplacement':
			return 'AssetReplacementOutput-v1'
		default:
			return module
	}
}

export const getInputName = (module: string) => {
	switch (module) {
		case 'budget':
			return 'BudgetInput-v1'
		case 'debtOverview':
			return 'DebtOverviewInput-v1'
		case 'incomeVerification':
			return 'IncomeVerificationInput-v1'
		case 'questionnaire':
			return 'QuestionnaireInput-v1'
		case 'customQuestionnaire':
			return 'CustomQuestionnaireInput-v1'
		case 'assetOverview':
			return 'AssetOverviewInput-v1'
		case 'assetExpenses':
			return 'AssetExpensesInput-v1'
		case 'assetReplacement':
			return 'AssetReplacementInput-v1'
		case 'savingsCapacity':
			return 'SavingsCapacityInput-v1'
		default:
			return module
	}
}
